<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<div class="customer-title-card">
				<h1>{{ "CUSTOMER_DETAILS.TITLE_ADVERTISER" | translate }} {{ customer?.id }} &ndash; {{ customer?.name }}</h1>
			</div>
		</mat-card-content>
	</mat-card>

	<div class="layout-container">
		<mat-card class="branding-customer-detail-card">
			<mat-card-content>
				<form [formGroup]="form" class="cass-customer-details-form">
					<mat-form-field class="span-2">
						<mat-label>{{ "CUSTOMER_DETAILS.ADVERTISER_NAME" | translate }}</mat-label>
						<input matInput formControlName="name" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="name"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.ORGANISATION_NUMBER" | translate }}</mat-label>
						<input matInput formControlName="organisationNumber" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="organisationNumber"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.PHONE" | translate }}</mat-label>
						<input matInput formControlName="phone" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="phone"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.MOBILE" | translate }}</mat-label>
						<input matInput formControlName="mobile" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="mobile"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.FAX" | translate }}</mat-label>
						<input matInput formControlName="fax" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="fax"></mat-error>
					</mat-form-field>
					<mat-form-field class="span-2">
						<mat-label>{{ "CUSTOMER_DETAILS.ADDRESS" | translate }}</mat-label>
						<input matInput formControlName="address" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="address"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CITY" | translate }}</mat-label>
						<input matInput formControlName="city" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="city"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.PROVINCE" | translate }}</mat-label>
						<input matInput formControlName="province" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="province"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.COUNTRY" | translate }}</mat-label>
						<mat-select [(value)]="Country" [disabled]="isReadOnly()">
							<mat-option *ngFor="let c of countries" [value]="c.code">{{c.label}}</mat-option>
						</mat-select>
						<mat-error [cassErrorForFormControl]="country"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.ZIPCODE" | translate }}</mat-label>
						<input matInput formControlName="zipcode" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="zipcode"></mat-error>
					</mat-form-field>
				</form>
			</mat-card-content>
			<mat-card-content>
				<div class="button-container">
					<button mat-raised-button color="primary" *ngIf="!isReadOnly()" [disabled]="!isValid()" (click)="modifyCustomer()">{{ "ACTION_BUTTON_LABELS.SAVE" | translate }}</button>
					<button mat-stroked-button *ngIf="!isReadOnly()" (click)="this.clickEditButton()">{{ "ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate }}</button>
					<button mat-stroked-button *ngIf="isReadOnly()" class="edit-button" (click)="this.clickEditButton()">{{ "ACTION_BUTTON_LABELS.EDIT" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding--customer-contact-section-card">
			<mat-card-content>
				<h2>{{ "CUSTOMER_DETAILS.CUSTOMER_CONTACTS" | translate }}</h2>
				<div>
					<mat-button-toggle-group #group="matButtonToggleGroup" [value]="selectedContactsFilterOption" (change)="onContactsFilterOptionChange(group.value)">
						<mat-button-toggle value="ContactsFilterOption.Sales">{{ "CUSTOMER_DETAILS.CONTACTS_FILTER.SALES" | translate }}</mat-button-toggle>
						<mat-button-toggle value="ContactsFilterOption.Material">{{ "CUSTOMER_DETAILS.CONTACTS_FILTER.MATERIAL" | translate }}</mat-button-toggle>
						<mat-button-toggle value="ContactsFilterOption.Proof">{{ "CUSTOMER_DETAILS.CONTACTS_FILTER.PROOF" | translate }}</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
				<div class="table-container">
					<table mat-table [dataSource]="filteredCustomerContacts">
						<ng-container matColumnDef="select">
							<th mat-header-cell *matHeaderCellDef>
								<mat-checkbox (change)="$event ? toggleAllRows() : null"
											  [checked]="contactSelection.hasValue() && isAllSelected()"
											  [indeterminate]="contactSelection.hasValue() && !isAllSelected()">
								</mat-checkbox>
							</th>
							<td mat-cell *matCellDef="let row">
								<mat-checkbox (click)="$event.stopPropagation()"
											  (change)="$event ? contactSelection.toggle(row) : null"
											  [checked]="contactSelection.isSelected(row)">
								</mat-checkbox>
							</td>
						</ng-container>
						<ng-container *ngFor="let column of customerContactTableColumnDefs" [matColumnDef]="column.key">
							<th mat-header-cell *matHeaderCellDef class="{{ column.class }}">{{ column.heading | translate }}</th>
							<td mat-cell
								*matCellDef="let row"
								[title]="column.value ? column.value(row) : row[column.key]"
								class="{{ column.class }}" (click)="clickedContact(row)"
								[ngClass]="{'default-contact': row.default}">
								{{ column.value ? column.value(row) : row[column.key] }}
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="customerContactTableDisplayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: customerContactTableDisplayedColumns"></tr>
					</table>
				</div>
				<div class="button-container">
					<button [disabled]="!isReadOnly()" mat-stroked-button (click)='addCustomerContact()'>{{ "ACTION_BUTTON_LABELS.NEW" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding--customer-address-section-card">
			<mat-card-content>
				<h2>{{ "CUSTOMER_DETAILS.CUSTOMER_ADDRESSES" | translate }}</h2>
				<div class="table-container">
					<table mat-table [dataSource]="customer?.addresses || []">
						<ng-container matColumnDef="select">
							<th mat-header-cell *matHeaderCellDef>
								<mat-checkbox (change)="$event ? toggleAllRows() : null"
											  [checked]="addressSelection.hasValue() && isAllSelected()"
											  [indeterminate]="addressSelection.hasValue() && !isAllSelected()">
								</mat-checkbox>
							</th>
							<td mat-cell *matCellDef="let row">
								<mat-checkbox (click)="$event.stopPropagation()"
											  (change)="$event ? addressSelection.toggle(row) : null"
											  [checked]="addressSelection.isSelected(row)">
								</mat-checkbox>
							</td>
						</ng-container>
						<ng-container *ngFor="let column of customerAddressTableColumnDefs" [matColumnDef]="column.key">
							<th mat-header-cell *matHeaderCellDef class="{{ column.class }}">{{ column.heading | translate }}</th>
							<td mat-cell
								*matCellDef="let row"
								[title]="row[column.key]"
								class="{{ column.class }}"
								(click)="clickedAddress(row)">
								{{ column.value ? column.value(row) : row[column.key] }}
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="customerAddressTableDisplayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: customerAddressTableDisplayedColumns"></tr>
					</table>
				</div>
				<div class="customer-address-action-buttons-container button-container">
					<button [disabled]="!isReadOnly()" mat-stroked-button (click)='addCustomerAddress()'>{{ "ACTION_BUTTON_LABELS.NEW" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding-customer-emails-section-card">
			<mat-card-content>
				<h2>{{ "CUSTOMER_DETAILS.CUSTOMER_EMAILS" | translate }}</h2>
				<div class="table-container">
					<table mat-table [dataSource]="customer?.emails || []">
						<ng-container matColumnDef="select">
							<th mat-header-cell *matHeaderCellDef>
								<mat-checkbox (change)="$event ? toggleAllRows() : null"
											  [checked]="emailSelection.hasValue() && isAllSelected()"
											  [indeterminate]="emailSelection.hasValue() && !isAllSelected()">
								</mat-checkbox>
							</th>
							<td mat-cell *matCellDef="let row">
								<mat-checkbox (click)="$event.stopPropagation()"
											  (change)="$event ? emailSelection.toggle(row) : null"
											  [checked]="emailSelection.isSelected(row)">
								</mat-checkbox>
							</td>
						</ng-container>
						<ng-container *ngFor="let column of customerEmailTableColumnDefs" [matColumnDef]="column.key">
							<th mat-header-cell *matHeaderCellDef class="{{ column.class }}">{{ column.heading | translate }}</th>
							<td mat-cell
								*matCellDef="let row"
								[title]="row[column.key]"
								class="{{ column.class }}"
								(click)="clickedEmail(row)">
								{{ row[column.key] }}
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="customerEmailTableDisplayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: customerEmailTableDisplayedColumns"></tr>
					</table>
				</div>
				<div class="customer-email-action-buttons-container button-container">
					<button [disabled]="!isReadOnly()" mat-stroked-button (click)='addCustomerEmail()'>{{ "ACTION_BUTTON_LABELS.NEW" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding--customer-website-section-card">
			<mat-card-content>
				<h2>{{ "CUSTOMER_DETAILS.CUSTOMER_WEBSITES" | translate }}</h2>
				<div class="table-container">
					<table mat-table [dataSource]="customer?.urls || []">
						<ng-container matColumnDef="select">
							<th mat-header-cell *matHeaderCellDef>
								<mat-checkbox (change)="$event ? toggleAllRows() : null"
											  [checked]="websiteSelection.hasValue() && isAllSelected()"
											  [indeterminate]="websiteSelection.hasValue() && !isAllSelected()">
								</mat-checkbox>
							</th>
							<td mat-cell *matCellDef="let row">
								<mat-checkbox (click)="$event.stopPropagation()"
											  (change)="$event ? websiteSelection.toggle(row) : null"
											  [checked]="websiteSelection.isSelected(row)">
								</mat-checkbox>
							</td>
						</ng-container>
						<ng-container *ngFor="let column of customerWebsiteTableColumnDefs" [matColumnDef]="column.key">
							<th mat-header-cell *matHeaderCellDef class="{{ column.class }}">{{ column.heading | translate }}</th>
							<td mat-cell
								*matCellDef="let row"
								[title]="row[column.key]"
								class="{{ column.class }}"
								(click)="clickedWebsite(row)">
								{{ row[column.key] }}
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="customerWebsiteTableDisplayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: customerWebsiteTableDisplayedColumns"></tr>
					</table>
				</div>
				<div class="customer-website-action-buttons-container button-container">
					<button [disabled]="!isReadOnly()" mat-stroked-button (click)='addCustomerWebsite()'>{{ "ACTION_BUTTON_LABELS.NEW" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding--advertisers-action-card button-container">
			<mat-card-content>
				<button mat-stroked-button [disabled]="!isReadOnly()" routerLink="/advertisers"><mat-icon>supervisor_account</mat-icon>{{ "CUSTOMER_DETAILS.ACTION_BUTTON_LABELS.ADVERTISERS_LIST" | translate }}</button>
			</mat-card-content>
		</mat-card>
	</div>
</div>
